import React from 'react';
import PropTypes from 'prop-types';
import { sampleSize, get } from 'lodash';
import withData from '@bd/bdcore-data';
import LightBox from '@bd/bdui-lightbox';
import YoutubeThumbnail from '@bd/bdui-youtubethumbnail';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';

import { colors } from '../styles';

const styles = css`
  display: flex;
  flex-direction: column;
  padding: 10px 0 100px;

  h3 {
    font-size: 33px;
    color: ${colors.brand1};
    font-weight: 500;
    text-align: center;
    padding: 20px 0;
    z-index: 10;
    @media(min-width: 768px) {
      font-size: 45px;
    }
  }

  .Video_wrapper {
    display: flex;
    flex-wrap: wrap;
    z-index: 10;
    justify-content: center;
  }
  .Video_wrapper div {
    width: 100%;
    margin: 5px;
    cursor: pointer;
    position: relative;
    @media(min-width: 992px) {
      width: 60%;
    }
    @media(min-width: 1390px) {
      width: 48.53%;
    }
  }

  .Video_overlay {
    position: absolute !important;
    width: 100% !important;
    height: 100%;
    background-color: rgba(51,51,51,0.4);
    color: rgba(60, 157, 199, 0.85);
    top: 0;
    margin: 0 !important;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
    transition: all .3s ease-out;
    &:hover {
      background-color: rgba(43, 102, 144, 0.6);
      color: rgba(43, 102, 144, 5.4);
      transition: all .3s ease-out;
      img {
        opacity: .8;
        transition: all .3s ease-out;
      }
    }

    img {
      width: 80px;
      height: 65px;
      transition: all .3s ease-out;
    }
  }

  .VideoItem_wrapper {
    width: 100% !important;
    margin: 0 !important;
  }
`;

const videoCss = css`
  margin: 10vh auto 0;
  @media (min-width: 992px) {
    width: 75vw;
    margin: 10vh auto 0;
  }
`;

function VideoGalleryList({ video, title, thumb }) {
  return (
    <div className={styles}>
      <h3>{title} {video.length > 1 ? 'Videos' : 'Video'}</h3>
      <div className="Video_wrapper">
        {
          sampleSize(video, 6).map(item => (
            <LightBox
              key={item}
              items={[
                {
                  element: (
                    <div
                      className={`${videoCss} embed-responsive embed-responsive-16by9`}
                      dangerouslySetInnerHTML={SanitizeHtml(item)}
                    />
                  ),
                },
              ]}
            >
              <div className="VideoItem_wrapper">
                {
                  thumb &&
                  <img src={get(thumb, 'contentUrl')} alt="Thumbnail" />
                }
                {
                  !thumb &&
                  <YoutubeThumbnail
                    className={css`
                      width: 100% !important;
                      margin: 0 !important;
                    `}
                    video={item}
                    index={0}
                  />
                }
                <div className="Video_overlay">
                  <img src="/images/icon-play.svg" alt="Play Icon" />
                </div>
              </div>
            </LightBox>
          ))
        }
      </div>
    </div>
  );
}

VideoGalleryList.propTypes = {
  video: PropTypes.arrayOf(PropTypes.string).isRequired,
  title: PropTypes.string,
  thumb: PropTypes.object,
};

VideoGalleryList.defaultProps = {
  title: '',
  thumb: null,
};

export default withData(
  {
    video: true,
  },
)(VideoGalleryList);



// WEBPACK FOOTER //
// ./src/components/VideoGalleryList.js